module.exports = __webpack_public_path__ + "media/images/lazy-placeholder-100627fdec1521f67a8a145422e9dbe0.png";